import styled from 'styled-components';
import { rem } from 'polished';
import { EngineSelectStyled } from '../../EngineSelectStyled';

export const EngineSelectStyledOVGB = styled(EngineSelectStyled)`
    .engineTitle {
        font-size: ${rem(16)};

        .selectedBorder {
            border: 1px solid ${({ theme }) => theme.colors.primary};
        }
    }

    .engineDescription {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        color: ${({ theme }) => theme.colors.grey1};
    }

    .enginePrice {
        font-size: ${({ theme }) => theme.fontSizes.h5};
    }

    .isSelected {
        background: ${({ theme }) => theme.colors.red7};
    }
`;
